<template>
	<!-- 唯一根元素：所有内容必须放在这个div里面 -->
	<div style="height:100%;display:flex;flex-direction:column;overflow:hidden;position:relative;width:100%">
		<!-- 顶部栏：学生按钮图标在右边，层级最高 -->
		<el-button class="show-on-mobile student-btn-right-icon" size=""
			style="width: 30px;right: 0%;position: absolute;height: 30px;margin-top: 100px;z-index: 1000;"
			type="success" @click="showStudentDrawer = true">
			<i class="el-icon-user" style="font-size: 20px;"></i>
		</el-button>
		<div class="top-bar"
			style="background:#1E88E5;color:#fff;padding:12px 20px;display:;justify-content:space-between;z-index:10;flex-shrink:0;align-items:center">
			<h3 style="margin:0"  @click="$router.back()">返回：{{ courseName }}</h3>
		</div>
		<div class="left-sidebar"
			style="position:absolute;left:0;top:0;bottom:0;width:280px;background:#f5f7fa;padding:16px;overflow-y:auto;z-index:5">
			<div style="margin-bottom:16px;padding:10px;background:#fff;border-radius:6px">
				<h4 style="margin:0 0 8px 0">班级学生（{{ totalData.totalStudent || 0 }}人）</h4>
				<el-radio-group v-model="statusFilter" @change="filterStudentList" size="small">
					<el-radio label="all">全部</el-radio>
					<el-radio label="online">在线</el-radio>
					<el-radio label="offline">退出</el-radio>
					<el-radio label="noline">未进入</el-radio>
				</el-radio-group>
				<div style="margin-top:8px;font-size:12px;color:#666;line-height:1.5">
					<div>在线：{{ totalData.onlineCount || 0 }}人 | 离线：{{ totalData.quitCount || 0 }}人 |
						未进入：{{ totalData.unOpenedCount || 0 }}人</div>
					<div>学生输入：{{ totalData.totalStudentChat || 0 }}条 | AI回复：{{ totalData.totalAiChat || 0 }}条 |
						教师干预：{{ totalData.totalTeacherIntervene || 0 }}条</div>
				</div>
			</div>
			<div v-for="item in filteredStudentList" :key="item.studentId" style="margin-bottom:8px;cursor:pointer"
				@click="selectStudent(item)">
				<el-button block :type="currentStudentId === item.studentId ? 'primary' : 'default'" icon="el-icon-user"
					style="text-align:left;justify-content:flex-start;gap:8px;align-items:center">
					<i :class="item.status === 1 ? 'el-icon-circle-check' : 'el-icon-circle-close'"
						:style="item.status === 1 ? 'color:#67C23A' : 'color:#F56C6C'"></i>
					<span style="flex:1">{{ item.studentName }}</span>
					<span :style="item.status === 1 ? 'color:#67C23A;font-size:12px' : 'color:#F56C6C;font-size:12px'">
						{{ item.status === 0 ? '未进入' : item.status === 1 ? '在线' : '退出' }}
					</span>
					<el-badge :value="`总:${item.studentChatCount+item.aiChatCount+item.teacherInterveneCount}`"
						size="mini" type="primary" style="margin-right:2px">
						<span style="visibility:hidden">·</span>
					</el-badge>
				</el-button>
			</div>
		</div>

		<!-- 右侧聊天区域 完全不动包裹结构 -->
		<div class="chat-wrap" style="position:absolute;left:280px;top:0;right:0;bottom:0;z-index:4;overflow:hidden">
			<div style="height:100%;width:100%;padding:20px;background:#f9f9f9;display:flex;flex-direction:column">
				<div class="chat-title"
					style="font-weight:600;color:#333;margin-bottom:12px;padding-bottom:8px;border-bottom:1px solid #eee">
					{{ currentStudentName || '暂未选择学生' }}
				</div>
				<div v-if="!currentStudentId" class="empty-tip"
					style="flex:1;display:flex;align-items:center;justify-content:center;color:#999">
					请点击左侧学生查看对话
				</div>
				<div v-else style="flex:1;overflow-y:auto;margin-bottom:16px" id="chatContainer">
					<div v-for="(msg, idx) in chatList" :key="idx" class="msg-item" :class="msg.role">
						<div class="avatar">
							{{ msg.role === 'student' ? '👨‍🎓' : (msg.role === 'ai' ? '🤖' : '👨‍🏫') }}
						</div>
						<div class="msg-content">
							<div class="msg-time">{{ formatTime(msg.createTime) }}</div>
							{{ msg.content }}
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Element原生抽屉：确保能渲染 -->
		<el-drawer :visible.sync="showStudentDrawer" direction="rtl" size="280px" :modal-append-to-body="false"
			:append-to-body="true" title="班级学生">
			<div style="padding:16px;height:100%;overflow-y:auto;background:#f5f7fa">
				<div style="margin-bottom:16px;padding:10px;background:#fff;border-radius:6px">
					<el-radio-group v-model="statusFilter" @change="filterStudentList" size="small">
						<el-radio label="all">全部</el-radio>
						<el-radio label="online">在线</el-radio>
						<el-radio label="offline">退出</el-radio>
						<el-radio label="noline">未进入</el-radio>
					</el-radio-group>
				</div>
				<div v-for="item in filteredStudentList" :key="item.studentId" style="margin-bottom:8px;cursor:pointer"
					@click="selectStudent(item);showStudentDrawer=false">
					<el-button block :type="currentStudentId === item.studentId ? 'primary' : 'default'"
						icon="el-icon-user"
						style="text-align:left;justify-content:flex-start;gap:8px;align-items:center">
						<i :class="item.status === 1 ? 'el-icon-circle-check' : 'el-icon-circle-close'"
							:style="item.status === 1 ? 'color:#67C23A' : 'color:#F56C6C'"></i>
						<span style="flex:1">{{ item.studentName }}</span>
						<span
							:style="item.status === 1 ? 'color:#67C23A;font-size:12px' : 'color:#F56C6C;font-size:12px'">
							{{ item.status === 0 ? '未进入' : item.status === 1 ? '在线' : '退出' }}
						</span>
					</el-button>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				showStudentDrawer: false,
				schoolId: localStorage.getItem('orgId'),
				teacherId: localStorage.getItem('userId'),
				courseClassId: '',
				courseName: '课堂',
				studentList: [],
				filteredStudentList: [],
				statusFilter: 'all',
				currentStudentId: '',
				currentStudentName: '',
				chatList: [],
				controlStudentPage: 0,
				timer: null,
				statusTimer: null,
				totalData: {},
				teacherInputContent: ''
			}
		},
		created() {
			// 全局错误捕获
			window.onerror = function(message, source, lineno, colno, error) {
				if (message && message.includes('notice.avoidance is not a function')) {
					return true;
				}
				return false;
			};

			// 路由参数双重保障
			this.courseClassId = this.$route.query.courseClassId || sessionStorage.getItem('courseClassId') || '';
			this.courseName = this.$route.query.courseName || sessionStorage.getItem('courseName') || '课堂';

			// 参数校验
			if (!this.courseClassId) {
				this.$message.error('页面参数异常，正在返回');
				setTimeout(() => this.$router.back(), 1500);
				return;
			}

			// 缓存参数
			sessionStorage.setItem('courseClassId', this.courseClassId);
			sessionStorage.setItem('courseName', this.courseName);

			this.getStudentList();
			this.getCourseName();
		},
		beforeDestroy() {
			// 清理定时器
			if (this.timer) clearInterval(this.timer);
			if (this.statusTimer) clearInterval(this.statusTimer);
			// 清理全局错误捕获
			window.onerror = null;
		},
		methods: {
			// 所有方法 完全原样不动
			scrollBottom() {
				this.$nextTick(() => {
					let container = document.getElementById('chatContainer')
					if (container) {
						container.scrollTop = container.scrollHeight
					}
				})
			},
			formatTime(timestamp) {
				if (!timestamp) return ''
				const date = new Date(timestamp)
				const y = date.getFullYear()
				const m = String(date.getMonth() + 1).padStart(2, '0')
				const d = String(date.getDate()).padStart(2, '0')
				const h = String(date.getHours()).padStart(2, '0')
				const min = String(date.getMinutes()).padStart(2, '0')
				const s = String(date.getSeconds()).padStart(2, '0')
				return `${y}-${m}-${d} ${h}:${min}:${s}`
			},
			async getCourseName() {
				try {
					const {
						data
					} = await this.API.get(this.API.school.getInfoById, {
						courseClassId: this.courseClassId
					})
					if (data.code === 200) {
						this.courseName = data.data.courseName || '课堂'
						this.controlStudentPage = data.data.controlStudentPage
					}
				} catch (e) {
					console.error('获取课堂名称失败：', e)
				}
			},
			async getStudentList() {
				try {
					const {
						data
					} = await this.API.get(this.API.school.getCreateStudentList, {
						schoolId: this.schoolId,
						courseClassId: this.courseClassId
					});
					this.studentList = data.data.studentList || [];
					this.totalData = data.data.total || {};
					this.studentList.sort((a, b) => b.status - a.status);
					this.filterStudentList();
				} catch (e) {
					console.error('获取学生列表失败：', e);
				}
			},
			filterStudentList() {
				if (this.statusFilter === 'all') {
					this.filteredStudentList = [...this.studentList]
				} else if (this.statusFilter === 'online') {
					this.filteredStudentList = this.studentList.filter(item => item.status === 1)
				} else if (this.statusFilter === 'noline') {
					this.filteredStudentList = this.studentList.filter(item => item.status === 0)
				} else if (this.statusFilter === 'offline') {
					this.filteredStudentList = this.studentList.filter(item => item.status === 2)
				}
			},
			async selectStudent(student) {
				this.currentStudentId = student.studentId
				this.currentStudentName = student.studentName
				clearInterval(this.timer)
				try {
					const {
						data
					} = await this.API.get(this.API.school.getWithRoleList, {
						schoolId: this.schoolId,
						courseClassId: this.courseClassId,
						studentId: this.currentStudentId
					})
					this.chatList = data.data || []
					this.scrollBottom()
				} catch (e) {
					console.error('加载对话失败：', e)
					this.chatList = []
				}
			},
			lock(type) {
				this.API.post(this.API.school.updateControlStudentPage, {
					courseClassId: Number(this.courseClassId),
					controlStudentPage: type,
					teacherId: Number(this.teacherId),
				}).then(res => {
					this.controlStudentPage = type
					if (type === 1) {
						alert('已锁屏，学生端将无法操作！')
					} else {
						alert('已解锁，学生端可以继续操作！')
					}
				})
			},
			async endClass() {
				if (confirm('确定要结束课堂吗？')) {
					try {
						await this.API.post(this.API.school.endClass, {
							courseClassId: this.courseClassId,
							teacherId: this.teacherId
						})
						alert('课堂已结束')
						this.$router.push('/teacher/index')
					} catch (e) {
						alert('结束失败')
					}
				}
			},
			async sendTeacherMsg() {
				const content = this.teacherInputContent.trim()
				if (!content) {
					this.$message.warning('请输入干预消息内容！')
					return
				}
				if (!this.currentStudentId) {
					this.$message.warning('请先选择要干预的学生！')
					return
				}
				try {
					const {
						data
					} = await this.API.post(this.API.school.postStudentChat, {
						schoolId: Number(this.schoolId),
						courseClassId: Number(this.courseClassId),
						studentId: Number(this.currentStudentId),
						teacherId: Number(this.teacherId),
						content: content,
						role: 'teacher'
					})
					if (data.code === 200) {
						this.teacherInputContent = ''
						this.$message.success('干预消息发送成功！')
						this.selectStudent({
							studentId: this.currentStudentId,
							studentName: this.currentStudentName
						})
						this.getStudentList()
					} else {
						this.$message.error('发送失败：' + (data.msg || '服务器错误'))
					}
				} catch (e) {
					console.error('发送教师干预消息失败：', e)
					this.$message.error('发送失败，请重试！')
				}
			},
		}
	}
</script>

<style scoped>
	* {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
	}

	.el-badge {
		margin-left: 2px !important;
	}

	.el-button:hover {
		opacity: 0.9;
		transition: all 0.2s;
	}

	::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}

	::-webkit-scrollbar-thumb {
		border-radius: 4px;
		background: #ccc;
	}

	::-webkit-scrollbar-track {
		background: #f5f5f5;
	}

	/* 只放大顶部栏文字 */
	.top-bar h3 {
		font-size: 20px;
		font-weight: bold;
	}

	.top-bar .el-button {
		font-size: 16px !important;
	}

	/* 学生按钮：图标在右边，层级最高 */
	.student-btn-right-icon {
		z-index: 9999 !important;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	/* 只放大聊天区域文字，不动包裹结构 */
	.chat-title {
		font-size: 20px !important;
		font-weight: bold;
	}

	.empty-tip {
		font-size: 18px;
	}

	.avatar {
		font-size: 32px;
		margin: 0 12px;
	}

	.msg-content {
		font-size: 18px;
		line-height: 1.7;
		padding: 14px 18px;
		border-radius: 14px;
	}

	.msg-time {
		font-size: 14px;
		margin-bottom: 8px;
	}

	.input-area .el-input,
	.input-area .el-button {
		font-size: 16px !important;
	}

	/* 学生列表文字完全保持原样 */
	.msg-time {
		font-size: 12px;
		color: rgba(255, 255, 255, 0.7);
		margin-bottom: 6px;
	}

	.msg-item {
		display: flex;
		margin: 20px 0;
		max-width: 90%;
		width: fit-content;
	}

	.msg-item.student,
	.msg-item.ai {
		margin-right: auto;
		flex-direction: row;
	}

	.msg-item.teacher {
		margin-left: auto;
		flex-direction: row-reverse;
	}

	.avatar {
		font-size: 30px;
		margin: 0 20px;
		display: flex;
		align-items: flex-start;
		padding-top: 5px;
	}

	.msg-content {
		background: #f1f1f1;
		padding: 18px 24px;
		border-radius: 20px;
		font-size: 18px;
		line-height: 1.8;
		box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
		white-space: pre-wrap;
		word-break: break-all;
	}

	.msg-item.student .msg-content {
		background: #2d8cf0;
		color: #fff;
	}

	.msg-item.ai .msg-content {
		background: #67C23A;
		color: #fff;
	}

	.msg-item.teacher .msg-content {
		background: #ff7d00;
		color: #fff;
	}

	:deep(.el-textarea__inner) {
		border-radius: 8px !important;
		font-size: 16px !important;
		padding: 12px !important;
		height: 40px !important;
		overflow-x: auto !important;
		overflow-y: hidden !important;
		white-space: nowrap !important;
	}

	:deep(.el-button--primary) {
		border-radius: 8px !important;
		font-size: 16px !important;
	}

	/* 响应式：学生列表文字完全保持原样，只放大其他部分 */
	.show-on-mobile {
		display: none !important;
	}

	@media (max-width: 1024px) {
		.left-sidebar {
			display: none !important;
		}

		.chat-wrap {
			left: 0 !important;
		}

		.show-on-mobile {
			display: inline-block !important;
		}

		/* 手机端只放大顶部和聊天区域，学生列表文字不变 */
		.top-bar h3 {
			font-size: 22px;
		}

		.top-bar .el-button {
			font-size: 18px !important;
		}

		.chat-title {
			font-size: 22px !important;
		}

		.empty-tip {
			font-size: 20px;
		}

		.avatar {
			font-size: 36px;
		}

		.msg-content {
			font-size: 20px;
			padding: 16px 20px;
		}

		.msg-time {
			font-size: 15px;
		}

		.input-area .el-input,
		.input-area .el-button {
			font-size: 18px !important;
		}
	}
	el-icon {
		
	}
</style>